import React, { useEffect, useState } from "react";
import Table from 'UI/Table';
import moment from 'moment'
import Icon from 'UI/FontAwesomeIcon'
import { isEmpty } from "lodash";
import { Query } from "Utilities/incognitaAPI";

const GET_IMPORT_AUDITS = `
  query GetImportAudits($id: Int!) {
    importConfigurationReportImportAudits(id: $id) {
      id
      error
      createdAt
      importDurationHumanized
      importFileName
      fileSizeHumanized
      fileRowCount
    }
  }
`

const COLUMNS = [
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'File Name', accessor: 'importFileName' },
  { Header: 'Error', accessor: 'error' },
  { Header: 'File Size', accessor: 'fileSizeHumanized', width: 150 },
  { Header: 'File Rows', accessor: 'fileRowCount', width: 150 },
  { Header: 'Duration', accessor: 'importDurationHumanized', width: 150 },
  { Header: 'Created At', accessor: 'createdAt', width: 200, Cell: row => (
    <div className="text-center">
      {row.value ?
        moment.utc(new Date(row.value)).format('YYYY-MM-DD  hh:mm A') :
        <Icon icon="minus" className="text-2xl text-gray-700" />
      }
    </div>
  )}
]

const ImportAudits = ({ id }) => {
  const [data, setData] = useState([])
  const [errors, setErrors] = useState([])
  const [loading, setLoading] = useState([])


  const fetchData = () => {
    setLoading(true)

    Query(GET_IMPORT_AUDITS, { id })
    .then((res) => {
      if (res?.errors) {
        setErrors(res.errors.map(e => e.message))
        setData([])
      } else {
        setData(res?.importConfigurationReportImportAudits)
        setErrors([])
      }
    })
    .catch(error => setErrors([error]))
    .finally(() => setLoading(false))
  }

  useEffect(fetchData, [])

  const NoDataComponent = () => {
    if (!isEmpty(errors)) return (
      <div className="text-center text-red-600 py-4">
        ERROR: {errors.join(', ')}
      </div>
    )

    return (
      <div className="text-center font-medium text-lg py-3 text-gray-700">
        No Issues
      </div>
    )
  }

  return (
    <Table
      columns={COLUMNS}
      data={data}
      NoDataComponent={NoDataComponent}
      loading={loading}
    />
  )
}

export default ImportAudits
